import { Fragment, useState, useEffect, useMemo } from "react";
import { useHistory, Route } from "react-router-dom";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import Resize from "src/components/common/resize";
import TransitionWidthHeight from "src/components/common/TransitionWidthHeight";
//--------------------------------------------------------------------------------------------
import LocatorForm from "src/components/outside/locator/locatorForm";
import LocatorEmergencyForm from "src/components/outside/locator/locatorEmergencyForm";
import OutsideBackupHistory from "src/components/outside/locator/outsideBackupHistory";
import {
    weekDays, 
    getDatefromWeekNum, 
    getDateEndFromWeekNum, 
    isDevMode, 
    getTimeStamp, 
    myAxios, MyFormData, 
    mimeTypeMap, 
    buildWeekNumArray,  
    defaultEmptyLocatorDataString, 
    statusColorCode, 
    descSort, 
    weeknum, 
    MyDate, 
    locatorStartDate as startDate,
    appTitle, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function LMTimeCard({ tabTitle }){
    const colorCode = e => <span style = {{color: statusColorCode(e)}}>{e}</span>;
    //--------------------------------------------------------------------------------------------
    const history = useHistory();
    const path = history.location.pathname;
    const path1 = path.split("/")[1];
    const path2 = path.split("/")[2];
    const path3 = path.split("/")[3];
    //--------------------------------------------------------------------------------------------
    const user = useMyStore(state => state.user);
    const [weeks] = useState(buildWeekNumArray(
        user.hireDate > startDate? user.hireDate : startDate,
        user.quitDate && new Date() > new Date(user.quitDate.replace(/-/g, "/"))?user.quitDate:((new MyDate()).s())
    ).reverse());
    const [week, setWeek] = useState((() => !weeks.includes(path2)?weeknum((new MyDate()).s()):path2));
    //--------------------------------------------------------------------------------------------
    const normalDayIndex = useMemo(() => 
        ["0", "1", "2", "3", "4", "5", "6"].includes(path3)?
        Number(path3):false
    , [path3]);
    //--------------------------------------------------------------------------------------------
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const divisions = useMyStore((state) => state.outsideserviceLocatorDivisions);
    const setDivisions = useMyStore((state) => state.setOutsideserviceLocatorDivisions);
    const forms = useMyStore((state) => state.outsideserviceLocatorForms);
    const setForms = useMyStore((state) => state.setOutsideserviceLocatorForms);
    const curForms = forms[week] ?? [];
    //--------------------------------------------------------------------------------------------
    const emergencyDayIndex = useMemo(() => 
        path3 && path3.slice(0, 1) === "e" && 
        path3.slice(1).match(/^[0-9]+$/) && 
        window.Number.parseInt(path3.slice(1)) >= 0 && 
        curForms.find(form => form.week === week) && 
        window.Number.parseInt(path3.slice(1)) < 
        curForms.find(form => form.week === week).emergency?.length?
        window.Number.parseInt(path3.slice(1)):false
    , [path3]);
    //--------------------------------------------------------------------------------------------
    const [updateDateTime, setUpdateDateTime] = useState({
        "Forms": forms.updatedAt === null?getTimeStamp():forms.updatedAt, 
        "Divisions": divisions.updatedAt === null?getTimeStamp():divisions.updatedAt
    });
    //--------------------------------------------------------------------------------------------
    const [showLoading, setShowLoading] = useState(false);
    //--------------------------------------------------------------------------------------------
    const renderedForm = curForms.find(renderedForm => renderedForm.week === week);
    const [backupHistory, setBackupHistory] = useState([]);
    const [showBackupHistory, setShowBackupHistory] = useState(false);
    const loadBackupHistory = async() => {
        const formData = new MyFormData();
        formData.append("wk", week);
        setShowLoader(true);
        const res = await myAxios("outside/locator/readBackups.php", formData);
        setShowLoader(false);
        if(!res) return;
        setBackupHistory(res.data);
        setShowBackupHistory(true);
    };
    const restoreBackup = async(backup) => {
        if(!window.confirm(`Restore save from ${backup.time_created}?\n\nThis will replace the current week, and the current version will be backed up first.`)) return;
        const formData = new MyFormData();
        formData.append("backupId", backup.id);
        setShowLoader(true);
        const res = await myAxios("outside/locator/restoreBackup.php", formData);
        setShowLoader(false);
        if(!res) return;
        setShowBackupHistory(false);
        setBackupHistory([]);
        const timeStamp = getTimeStamp();
        setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
    };
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            //------------------------------
            setShowLoading(true);
            const resDivision = await myAxios("outside/divisions/readDivisions.php");
            if(!isMounted) return;
            setShowLoading(false);
            if(!resDivision) return;
            //------------------------------
            setDivisions(resDivision.data, updateDateTime["Divisions"]);
            if(normalDayIndex !== false){
                history.replace(`/${path1}/${week}/${String(normalDayIndex)}`);
            }else if(normalDayIndex !== false){
                history.replace(`/${path1}/${week}/${"e" + String(emergencyDayIndex)}`);
            }else{
                history.replace(`/${path1}/${week}`);
            }
        }
        if(updateDateTime["Divisions"] !== divisions.updatedAt) getData();
        return () => {isMounted = false;}
    },[updateDateTime["Divisions"]])
    //--------------------------------------------------------------------------------------------
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
        let isMounted = true;
        const getData = async () => {
            const formData = new MyFormData();
            formData.append("week", `\`outside\`.\`${week}\``);
            setShowLoading(true);
            const res = await myAxios("outside/locator/readTimeCard.php", formData);
            if(!isMounted) return;
            setShowLoading(false);
            //------------------------------
            const unordered = res.data;
            delete unordered.email;
            const ordered = Object.keys(unordered).sort(descSort).reduce(
            (obj, key) => {
                obj[key] = JSON.parse(unordered[key] || defaultEmptyLocatorDataString);
                return obj;
            },
            {})
            setForms(week, Object.entries(ordered).map(([key, value]) => ({...value, week: key})) || [], updateDateTime["Forms"]);
        }
        if(!forms[week] || (updateDateTime["Forms"] !== forms.updatedAt)) getData();
        return () => {isMounted = false;}
    },[week, updateDateTime["Forms"]])
    useEffect(() => {
        document.title = tabTitle;
        return () => {
            document.title = appTitle;
        };
    }, [tabTitle]);
    //--------------------------------------------------------------------------------------------
    return(
        <div className = "cssTab">
            <div className = "cssHeader" style = {{background: user.userTheme}}>
                <span>
                    <Resize/>
                    Time Card
                    <span
                        data-toggle = "tooltip"
                        title = {`Refreshed on ${Object.values(updateDateTime)[0]}.`}
                        className = "btn btn-primary py-1 ml-4"
                        onClick = {() => {
                            const timeStamp = getTimeStamp();
                            setUpdateDateTime(Object.fromEntries(Object.keys(updateDateTime).map(key => [key, timeStamp])));
                        }}
                    >
                        ↻
                    </span>
                </span>
                <span></span>
                <span className = "d-flex align-items-center">
                    <label htmlFor = "week" className = "mb-0">Week:</label>
                    <select
                        id = "week"
                        className = "form-control w-auto ml-2"
                        value = {week}
                        onChange = {e => {
                            setWeek(e.currentTarget.value);
                        }}
                    >
                        {weeks.map((k, key) => <option key = {key} value = {k}>{getDateEndFromWeekNum(k)}</option>)}
                    </select>
                </span>
            </div>
            <div>
            <div className = "cssContent pb10">
                {showLoading?<div className = "cssLoading">Loading...</div>:
                !renderedForm?<div className = "cssLoading">Empty</div>:
                <>
                <div className = "h3 text-danger font-weight-bold mt-2 mb-0 ml-2">{getDateEndFromWeekNum(renderedForm.week)}</div>
                {["Submitted", "Approved"].includes(curForms.find(form => form.week === week)?.status)?
                <div className = "h5 text-success mb-0 mt-2 ml-2">Submitted on {renderedForm.submitTime}</div>
                :<></>}
                <div className = "cssSeperateWhenWide px-1 mt-3 overflow-auto">
                    {weekDays.map((weekday, i) =>
                    <div className = "px-1" key = {i}>
                        <div className = "h4 text-secondary">{weekday} ({getDatefromWeekNum(renderedForm.week, i)})</div>
                        <div className = "my-3">
                            <span className = "font-weight-bold">Status: {colorCode(renderedForm.form[i].status)}</span>
                        </div>
                        <div className = "mt-2">
                            {!["Submitted", "Approved"].includes(renderedForm.status)?
                            <span
                                className = "btn btn-success"
                                onClick = {() => {
                                    history.push(`/${path1}/${renderedForm.week}/${i}`);
                                }}
                            >
                                Edit
                            </span>
                            :<></>}
                            {renderedForm.form[i].status === "Submitted"?
                            (renderedForm.form[i].workStatus === "Work" || renderedForm.form[i].workStatus === undefined?
                            <span
                                className = "btn btn-info ml-2"
                                onClick = {async() => {
                                    if(!renderedForm.form[i].id){
                                        window.alert("File Error.");
                                        return
                                    };
                                    const formData = new MyFormData();
                                    formData.append("fileId[]", renderedForm.form[i].id);
                                    //------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("common/getFile.php", formData, "blob");
                                    setShowLoader(false);
                                    if(!res) return;
                                    //------------------------------
                                    const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                    saveAs(file, `${getDatefromWeekNum(renderedForm.week, i).replace(/\//g,"-")}.pdf`);
                                }}
                            >
                                PDF
                            </span>
                            :
                            <span
                                className = "font-weight-bold ml-2"
                            >
                                {renderedForm.form[i].workStatus}
                            </span>
                            )
                            :null}
                        </div>
                    </div>)}
                </div>
                <div className = "d-flex px-1 mt-3">
                    {renderedForm.emergency?.map((e, i) =>
                    <div className = "px-1" key = {i}>
                        <div className = "h4 text-secondary">Emergency {i + 1}</div>
                        <div className = "text-secondary">{e.date}</div>
                        <div className = "mt-2">
                            <span className = "font-weight-bold">Status: {colorCode(e.status || "Created")}</span>
                        </div>
                        <div className = "mt-2">
                            {!["Submitted", "Approved"].includes(renderedForm.status)?<>
                            <span
                                className = "btn btn-success"
                                onClick = {() => {
                                    history.push(`/${path1}/${renderedForm.week}/e${i}`);
                                }}
                            >
                                Edit
                            </span>
                            <span
                                className = "btn btn-danger ml-2"
                                onClick = {async() => {
                                    if(!window.confirm("Are you sure to delete this emergency call out?")) return;
                                    const formData = new MyFormData();
                                    formData.append("wk", week);
                                    formData.append("index", i);
                                    //------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("outside/locator/emergency/delete.php", formData);
                                    setShowLoader(false);
                                    if(!res) return;
                                    //------------------------------
                                    const thisWeekForm = renderedForm;
                                    thisWeekForm.emergency = thisWeekForm.emergency.filter((_, index) => index !== i);
                                    setForms(week, curForms.map(form => form.week === week?{...thisWeekForm, week: week}:form));
                                }}
                            >
                                Delete
                            </span>
                            </>:<></>}
                            {e.status === "Submitted"?
                            ((e.workStatus === "Work" || e.workStatus === undefined) && e.id?
                            <span
                                className = "btn btn-info ml-2"
                                onClick = {async() => {
                                    if(!e.id){
                                        window.alert("File Error.");
                                        return
                                    };
                                    const formData = new MyFormData();
                                    formData.append("fileId[]", e.id);
                                    //------------------------------
                                    setShowLoader(true);
                                    const res = await myAxios("common/getFile.php", formData, "blob");
                                    setShowLoader(false);
                                    if(!res) return;
                                    //------------------------------
                                    const file = new Blob([res.data], {type: mimeTypeMap.pdf});
                                    saveAs(file, `${e.date}.pdf`);
                                }}
                            >
                                PDF
                            </span>
                            :
                            <span className = "font-weight-bold">{e.workStatus}</span>
                            )
                            :null}
                        </div>
                    </div>)}
                </div>
                <div className = "text-right mt-2">
                    <span
                        className = "btn btn-secondary mx-3"
                        onClick = {loadBackupHistory}
                    >
                        View Save History
                    </span>
                </div>
                {!["Submitted", "Approved"].includes(renderedForm.status)?
                <div className = "text-right mt-2 pb-3">
                    <span
                        className = "btn btn-warning mx-3"
                        onClick = {async() => {
                            const formData = new MyFormData();
                            formData.append("wk", week);
                            //------------------------------
                            setShowLoader(true);
                            const res = await myAxios("outside/locator/emergency/add.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------------
                            const thisWeekForm = curForms.find(form => form.week === week);
                            if(!thisWeekForm.emergency){
                                thisWeekForm.emergency = [];
                            }
                            thisWeekForm.emergency.push({data: [], status: "Created", overnight: false});
                            setForms(week, curForms.map(form => form.week === week?{...thisWeekForm, week: week}:form));
                        }}
                    >
                        Add Emergency Call Out
                    </span>
                    <span className = "btn btn-primary mx-3"
                        onClick = {async() => {
                            const thisForm = curForms.find(form => form.week === week);
                            const validateF = thisForm.form.map((ff, i) => ({...ff, date:getDatefromWeekNum(week, i)}))
                            .filter(ff => ff.status !== "Submitted");
                            if(validateF.length){
                                window.alert(`You need to submit following date(s) of time card first:\n${validateF.map(ff => ff.date).join(", ")}`)
                                return;
                            }
                            if(thisForm.emergency){
                                const validateFF = thisForm.emergency.map((form, i) => ({...form, i: i})).filter(ff => ff.status !== "Submitted");
                                if(validateFF.length){
                                    window.alert(`You need to submit following date(s) of ermengency time card first:\n${validateFF.map(ff => `Emergency ${ff.i + 1}`).join(", ")}`)
                                    return;
                                }
                            }
                            if(!window.confirm("Are you sure to submit for the week?\n(Note: after this submission, you are not able to edit this week.)")){
                                return;
                            }
                            const formData = new MyFormData();
                            formData.append("wk", week);
                            //------------------------------
                            setShowLoader(true);
                            const res = await myAxios("outside/locator/submitWeek.php", formData);
                            setShowLoader(false);
                            if(!res) return;
                            //------------------------------
                            setForms(week, curForms.map(form => form.week === week? 
                                {
                                    ...form,
                                    status: "Submitted"
                                }:form)
                            );
                        }}
                    >
                        Final submission for the week
                    </span>
                </div>:<></>}
                </>}
            </div>
            </div>
            {normalDayIndex !== false?
            <Route
                exact
                path = {`/${path1}/${week}/${path3}`}
                children = {
                    curForms.find(form => form.week === week)
                    /* && curForms.filter(form => form.week === week)[0].status !== "Submitted" */
                    ?
                    <LocatorForm
                        closeIt = {() => {history.push(`/${path1}/${week}`)}}
                        defaultData = {curForms.find(form => form.week === week)}
                        week = {week}
                        dayIndex = {normalDayIndex}
                        outside = {user.outside}
                    />:null
                }
            />
            :null}
            {emergencyDayIndex !== false?
            <Route
                exact
                path = {`/${path1}/${week}/${path3}`}
                children = {
                    curForms.find(form => form.week === week)
                    /* && curForms.filter(form => form.week === week)[0].status !== "Submitted" */
                    ?
                    <LocatorEmergencyForm
                        closeIt = {() => {history.push(`/${path1}/${week}`)}}
                        defaultData = {curForms.find(form => form.week === week)}
                        week = {week}
                        dayIndex = {emergencyDayIndex}
                    />:null
                }
            />
            :null}
            {showBackupHistory?
            <OutsideBackupHistory
                backups = {backupHistory}
                week = {week}
                closeIt = {() => setShowBackupHistory(false)}
                restoreBackup = {restoreBackup}
                currentWeekStatus = {renderedForm.status}
            />
            :null}
        </div>
    )
}